export const fullName = (item) => {
  if (!(item && item.firstName)) return '';
  return `${item.firstName} ${item.lastName || ''}`.trim();
};
